import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <rect x="15.46" y="15.46" width="29.79" height="29.79" />
    <polygon points="13.46 13.46 36.54 13.46 36.54 5.75 5.75 5.75 5.75 36.54 13.46 36.54 13.46 13.46" />
  </Base>
);
